import React from 'react'
import { BarProps } from 'recharts'

export type CustomBarProps = {
  minThickness?: number
} & BarProps

export const CustomBar: React.FC<CustomBarProps> = (props: CustomBarProps) => {
  const { stroke, fill, x, width } = props
  const minThickness = props.minThickness ?? 5

  const height = parseFloat(`${props.height}`)
  const barHeight = height < minThickness && height > -minThickness ? minThickness : height

  const y = parseFloat(`${props.y}`)
  const barY = height < 0 ? y + height : height < minThickness ? y + height - barHeight : y

  if (!isNaN(height) && !isNaN(y) && height !== 0) {
    return <rect x={x} y={barY} width={width} height={Math.abs(barHeight)} stroke={stroke} fill={fill} />
  } else {
    return <></>
  }
}
